module.exports = __webpack_public_path__ + "img/company2.1ecca57f.png";